import { Page } from "../../../TrifortCMS.Web.Common/Scripts/Common/page";
import { IRenderWikiOptions, IWikiLinkDefinition } from '../../../TrifortCMS.Web.Common/Scripts/interfaces';
import { TrifortCMSWikiService } from '../../../TrifortCMS.Web.Common/Scripts/UI/wiki-service';

class Wiki2Page extends Page {
    private _wikiService: TrifortCMSWikiService;

    public async initialise() {
        var self = this;

        self._wikiService = new TrifortCMSWikiService("#wiki");

        var wikiPages: IWikiLinkDefinition[] = [
            { title: "Introduction", pageFileName: "Introduction" },
            { title: "Depreciation Methods", pageFileName: "DepreciationMethods" },
            { title: "Entity Definition", pageFileName: "EntityDefinition" },
        ];

        var renderWikiOptions: IRenderWikiOptions = {
            wikiTitle: "Asset Tracker Wiki",
            wikiLinks: wikiPages,
            defaultLandingPageFileName: "introduction"
        }

        self._wikiService.RenderWiki(renderWikiOptions);
    }
}

var pageVm = new Wiki2Page();

pageVm.initialise();
